import React, { useState } from 'react';
import { Button } from '../ButtonElements';

import Video from '../../videos/video.mp4';
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight
} from './HeroElements';
import logo from '../../images/logo.png';
import '../../imageStyle/logo.css'
import litePaper from '../../images/Litepaper.pdf';

function HeroSection() {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };
  return (
    <HeroContainer id='home'>
      <HeroBg>
        <VideoBg playsInline autoPlay loop muted src={Video} type='video/mp4' />
      </HeroBg>
      <HeroContent>
        <HeroH1>Are You A Star?</HeroH1>
        <HeroP>


          Athletes sign up coming soon. Take control of your narrative!
        </HeroP>
        <HeroBtnWrapper>
        <Button
            primary='true'
            dark='true'
            onMouseEnter={onHover}
            onMouseLeave={onHover}

         >Litepaper Coming Soon
                {/* <a onClick={() => window.open(litePaper)} rel="noopener noreferrer" target="_blank">Litepaper</a> */}
                {hover ? <ArrowForward /> : <ArrowRight />}

        </Button>

          {/* <Button
            to='signup'
            smooth={true}
            duration={500}
            spy={true}
            exact='true'
            offset={-80}
            primary='true'
            dark='true'
            onMouseEnter={onHover}
            onMouseLeave={onHover}
          >
          
            Get Started {hover ? <ArrowForward /> : <ArrowRight />}
          </Button> */}
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
}

export default HeroSection;
